



















  import CheckboxGroupItem from '@/commun/components/champ-formulaire/checkbox-group/checkbox-group-item';
  import Vue, { PropType } from 'vue';
  import { Tooltip } from '@/commun/components/champ-formulaire/tooltip';

  export default Vue.extend({
    name: 'CheckboxGroup',
    components: { Tooltip },
    props: {
      label: {
        type: String,
        default: '',
      },
      items: {
        type: Array as PropType<Array<CheckboxGroupItem>>,
        default: new Array(0),
      },
    },
    methods: {
      onChangeValeurCheckbox(payload: CheckboxGroupItem): void {
        this.$emit('changeValeurCheckbox', payload);
      },
    },
  });
